import { useState, useEffect } from "react";
import { isDefined } from "@perxis-auto/shared/lib";
function useConstructorItemByType(type) {
  const [element, setElement] = useState(null);
  useEffect(() => {
    if (!isDefined(type)) {
      return;
    }
    const el = document.querySelector(`[data-widget-type="${type}"]`);
    setElement(el);
  }, [type]);
  return element;
}
export {
  useConstructorItemByType
};
